export class ROLES {
  public static readonly ADMIN = 'ADMIN';
  public static readonly REGULAR = 'REGULAR';
}
